import {
  Card,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  List,
  ListItem,
  Paper,
  Switch,
} from "@mui/material";
import { useMaterialUIController } from "context";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import getText from "Translator";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { getColleaguesFromServer } from "controllers/UserController";
import { displayErrorMessage } from "controllers/validation";

let file = "";
let selectedlist = [];
let list = [];

export default function SendToColleagueComponent(props) {
  const { selectedlistx, setSendColeagueHandler } = props;
  const [limitedSending, setLimitedSending] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [reload, setReload] = useState(new Date());
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);

  const initComponent = async () => {
    try {
      setLoading(true);
      let coleagueUsers = await getColleaguesFromServer(
        controller.lang,
        { search },
        controller.token
      );
      setLoading(false);
      if (coleagueUsers.success) {
        selectedlist = [];
        if (selectedlistx) {
          selectedlist = selectedlistx;
        }
        coleagueUsers.data.map((item) => {
          if (item.selected) {
            selectedlist.push(item);
          }
        });
        setSelected(selectedlist);
        setLimitedSending(coleagueUsers.limited);
        list = coleagueUsers.data;
     
        setData(coleagueUsers.data.sort((a, b) => a.selected - b.selected));
      } else {
        displayErrorMessage(
          controller.lang,
          getText("warningalert", controller.lang),
          coleagueUsers.code
        );
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  useEffect(() => {
    initComponent();
  }, []);
  useEffect(() => {
    editInit();
  }, [selectedlistx]);
  const editInit = async () => {
    try {
      if (selectedlistx.length > 0) {
        setLoading(true);
        let temp = await getColleaguesFromServer(
          controller.lang,
          { search },
          controller.token
        );
        setLoading(false);
        if (temp.success) {
          temp = temp.data;

          temp.map((item) => {
            if (
              selectedlistx.filter((a) => a.value + "" == item.value + "")
                .length > 0
            ) {
              item.selected = true;
              selectedlist.push(item);
            }
          });
          setSelected(selectedlist);
          temp.sort((a, b) => a.selected - b.selected);
          setData(temp);
        } else {
          displayErrorMessage(
            controller.lang,
            getText("warningalert", controller.lang),
            temp.code
          );
        }
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const searchChbSelect = async (search) => {
    let temp = list.filter((a) => a.text.toLowerCase().includes(search));
    temp.sort((a, b) => a.selected - b.selected);
    setData(temp);
  };

  const saveSendToColleague = async () => {
    let array = [];
    let newDatas = data.filter((s) => s.selected === true);
  };

  return (
    <div>
      <List style={{ marginTop: 10, maxHeight: 200, overflow: "auto" }}>
        {data &&
          data.map((item, index) => (
            <ListItem key={index + item.value + ""}>
              <FormControlLabel
                control={
                  <Switch
                    onChange={(event) => {
                      let coleagueUsers = data;
                      for (let sw of coleagueUsers) {
                        if (sw.value === item.value) {
                          sw.selected = event.target.checked;
                        }
                      }
                      if (!event.target.checked) {
                        selectedlist = selectedlist.filter(
                          (a) => a.value + "" !== item.value + ""
                        );
                      }
                      setSendColeagueHandler(
                        coleagueUsers.filter((a) => a.selected == true)
                      );
                      coleagueUsers.sort((a, b) => a.selected - b.selected);
                      setData(coleagueUsers);
                      setReload(new Date());
                    }}
                    trackColor="#039dfc"
                    checked={item.selected}
                  />
                }
                label={item.text}
              />
            </ListItem>
          ))}
      </List>

      <Grid container style={{ marginTop: 5, flex: 1, flexDirection: "row" }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
            padding: 0,
          }}
        >
          <Paper
            component="form"
            style={{
              bottom: "0 !important",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <IconButton
              color="primary"
              aria-label="CloseIcon"
              onClick={() => {
                searchChbSelect("");
                setSearch("");
              }}
            >
              <HighlightOffIcon />
            </IconButton>
            <InputBase
              value={search}
              fullWidth={true}
              autoFocus={true}
              onChange={(event) => {
                searchChbSelect(event.target.value);
                setSearch(event.target.value);
              }}
            />
            <IconButton color="primary" aria-label="search" onClick={() => {}}>
              <SearchIcon />
            </IconButton>
          </Paper>
          {/* <Button
              color="primary"
              onClick={() => {
                saveSendToColleague();
              }}
            >
              Add
            </Button> */}
        </Grid>
      </Grid>
    </div>
  );
}
